import { useState } from "react"

import { CalendarOutlined, CloseOutlined, CloudUploadOutlined, FileOutlined, FilePdfOutlined, InfoCircleOutlined, PictureOutlined, VideoCameraOutlined } from '@ant-design/icons'
import moment from "moment"
import { useAppSelector } from "shared/config/store"
import { toMb } from "shared/utils/filesUtils"
import { css, styled } from "styled-components"
import {
  getFilesPreviewItemsSelector
} from "features/files-preview/model/selectors/filesPreviewSelectors"
import classNames from "classnames"

export const AiAssistantInfoSidebar = ({ currentIndex }: { currentIndex: number }) => {
  const [sidebarOpened, setSidebarOpened] = useState(false)

  const items = useAppSelector(getFilesPreviewItemsSelector)

  const currentItem = items[currentIndex] as any

  const handleToggleSidebar = () => {
    setSidebarOpened(!sidebarOpened)
  }

  const fileInfo = currentItem?.file_info
  const metaData = fileInfo?.meta_data

  return (
    <>
      {!sidebarOpened && (
        <SSidebarToggle onClick={handleToggleSidebar}>
          <SInfoIcon />
        </SSidebarToggle>
      )}

      <SRightPanel className={classNames({ visible: sidebarOpened })}>
        <SInfoTabWrapper>
          <SHeader>
        Information
            <SCloseIcon onClick={handleToggleSidebar} />
          </SHeader>

          <SInfoTabContent>
            <SInfoContent>
              <SInfoRow>
                <SCalendarIcon />

                <SInfoRowRight>
                  <SInfoRowTitle>
                    {moment(currentItem?.created).format("MMM DD, YYYY")}
                  </SInfoRowTitle>

                  <SInfoRowValue>
Created
                  </SInfoRowValue>
                </SInfoRowRight>
              </SInfoRow>

              <SInfoRow>
                {fileInfo?.mime?.startsWith('image') ? (
                  <SImageIcon />
                ) : fileInfo?.mime?.startsWith('video') ? (
                  <SVideoIcon />
                ) : fileInfo?.mime?.startsWith('application/pdf') ? (
                  <SPdfIcon />
                ) : (
                  <SFileIcon />
                )}

                <SInfoRowRight>
                  <SInfoRowTitle>
                    {fileInfo?.mime}

                  </SInfoRowTitle>

                  <SInfoRowValue>
                    {toMb(fileInfo?.size)}

                    <p>
                      {metaData?.image && `size: ${metaData?.image?.width} x ${metaData?.image?.height} px`}
                    </p>

                    <p>
                      {metaData?.video && `size: ${metaData?.video?.width} x ${metaData?.video?.height} px`}
                    </p>

                    <p>
                      {metaData?.video && `video codec: ${metaData?.video?.video_codec_name}`}
                    </p>

                    <p>
                      {metaData?.video && `audio codec: ${metaData?.video?.audio_codec_name}`}
                    </p>

                  </SInfoRowValue>
                </SInfoRowRight>
              </SInfoRow>

              <SInfoRow>
                <SUploadIcon />

                <SInfoRowRight>
                  <SInfoRowTitle>
                    {moment(currentItem?.updated).format("MMM DD, YYYY")}
                  </SInfoRowTitle>

                  <SInfoRowValue>
            Updated
                  </SInfoRowValue>
                </SInfoRowRight>
              </SInfoRow>
            </SInfoContent>
          </SInfoTabContent>
        </SInfoTabWrapper>
      </SRightPanel>
    </>
  )
}

const SRightPanel = styled.div`
  height: 100%;
  width: 360px;
  border-top: 1px solid rgba(48, 48, 48, 1);
  background-color: rgba(31, 31, 31, 1);
  position: relative;
  position: absolute;
  right: 0;
  display: none;

  &.visible {
    display: block;
  }
`

const SInfoTabWrapper = styled.div`
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  min-height: 0;
`

const SInfoTabContent = styled.div`
  padding: 24px 24px 24px 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`

const SInfoRow = styled.div`
  margin-bottom: 24px;
  display: flex;
  gap: 15px;
`

const SInfoRowRight = styled.div``

const SInfoRowTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
`

const SInfoRowValue = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.65);
`

const iconStyles = css`
  height: 30px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 24px;
`

const SCalendarIcon = styled(CalendarOutlined)`
  ${iconStyles}
`

const SImageIcon = styled(PictureOutlined)`
  ${iconStyles}
`

const SVideoIcon = styled(VideoCameraOutlined)`
  ${iconStyles}
`

const SPdfIcon = styled(FilePdfOutlined)`
  ${iconStyles}
`

const SFileIcon = styled(FileOutlined)`
  ${iconStyles}
`

const SUploadIcon = styled(CloudUploadOutlined)`
  ${iconStyles}
`

const SInfoContent = styled.div`
  margin-bottom: 32px;
`

const SHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #FFFFFFD9;
  border-bottom: 1px solid #FFFFFF1A;
`

const SCloseIcon = styled(CloseOutlined)`
  font-size: 24px;
  color: #FFFFFF73;
`

const SSidebarToggle = styled.div`
  position: absolute;
  top: 16px;
  right: 24px;
  width: 32px;
  height: 32px;
  background-color: #1F1F1F;
  border-radius: 8px;
  border: 1px solid #424242;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
`

const SInfoIcon = styled(InfoCircleOutlined)`
  font-size: 20px;
  color: #FFFFFFD9;
`